import styled from '@emotion/styled';
import { Box, Card } from '@mui/material';
import { alpha } from '@mui/material';
import { colors } from 'Constants/Colors';
import { keyframes } from '@emotion/react';

const sadAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0);
  }
`;

const celebrationAnimation = keyframes`
  0% {
    transform: scale(0) rotate(0deg);
    opacity: 0;
  }
  50% {
    transform: scale(1.2) rotate(180deg);
    opacity: 1;
  }
  100% {
    transform: scale(1) rotate(360deg);
    opacity: 1;
  }
`;

const fallingConfetti = keyframes`
  0% {
    transform: translateY(-10vh) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(100vh) rotate(360deg);
    opacity: 0;
  }
`;

const fallingRain = keyframes`
  0% {
    transform: translateY(-10vh);
    opacity: 0.8;
  }
  100% {
    transform: translateY(100vh);
    opacity: 0.3;
  }
`;

export const ConfettiContainer = styled(Box)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
`;

interface ConfettiPieceProps {
  $delay: number;
  $left: number;
}

export const ConfettiPiece = styled(Box)<ConfettiPieceProps>`
  position: absolute;
  width: 10px;
  height: 10px;
  background: ${() => {
    const colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff'];
    return colors[Math.floor(Math.random() * colors.length)];
  }};
  top: -20px;
  left: ${({ $left }) => $left}%;
  animation: ${fallingConfetti} 3s linear infinite;
  animation-delay: ${({ $delay }) => $delay}s;
  transform-origin: center;
`;

interface RainDropProps {
  $delay: number;
  $left: number;
}

export const RainDrop = styled(Box)<RainDropProps>`
  position: absolute;
  width: 2px;
  height: 20px;
  background: ${alpha(colors.BLUE, 0.5)};
  top: -20px;
  left: ${({ $left }) => $left}%;
  animation: ${fallingRain} 1s linear infinite;
  animation-delay: ${({ $delay }) => $delay}s;
  transform-origin: center;
  border-radius: 999px;
  box-shadow: 0 0 5px ${alpha(colors.BLUE, 0.3)};
`;

export const CalificationWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  width: 100%;
  padding: 2rem;
  position: relative;
  z-index: 1;
`;

interface CalificationCardProps {
  $isApproved: boolean;
}

export const CalificationCard = styled(Card)<CalificationCardProps>`
  padding: 2rem;
  max-width: 600px;
  width: 100%;
  transition: all 0.3s ease;
  background-color: ${({ $isApproved }) => ($isApproved ? alpha(colors.GREEN, 0.1) : alpha(colors.RED, 0.1))};
  position: relative;
  z-index: 2;
  backdrop-filter: blur(5px);

  .sad-emoji {
    animation: ${sadAnimation} 2s ease-in-out infinite;
  }

  .celebration-emoji {
    animation: ${celebrationAnimation} 1s ease-out;
    display: inline-block;
  }
`;
